import { specialistList_specialistList_data } from "@/__generated__/listings";

export const SPECIALIST_SLOT_NUMBER_SLOT_MANDATORY =
  "SPECIALIST_SLOT_NUMBER_SLOT_MANDATORY";
export const SPECIALIST_SLOT_NUMBER_LISTING_MANDATORY =
  "SPECIALIST_SLOT_NUMBER_LISTING_MANDATORY";
export const SPECIALIST_SLOT_PRODUCT_GROUP_CODE_MANDATORY =
  "SPECIALIST_SLOT_PRODUCT_GROUP_CODE_MANDATORY";
export const SPECIALIST_SLOT_NUMBER_SLOT_MIN =
  "SPECIALIST_SLOT_NUMBER_SLOT_MIN";
export const SPECIALIST_SLOT_NUMBER_LISTING_MIN =
  "SPECIALIST_SLOT_NUMBER_LISTING_MIN";
export const SPECIALIST_SLOT_PRODUCT_GROUP_CODE_INVALID =
  "SPECIALIST_SLOT_PRODUCT_GROUP_CODE_INVALID";
export const SPECIALIST_SLOT_UPDATE_FAILED = "SPECIALIST_SLOT_UPDATE_FAILED";

export const AGENT_MUST_HAS_ONLINE_LISTING = "AGENT_MUST_HAS_ONLINE_LISTING";
export const AGENT_MUST_HAS_PROFILE_PHOTO = "AGENT_MUST_HAS_PROFILE_PHOTO";
export const AGENT_MUST_HAS_LICENSE_NO = "AGENT_MUST_HAS_LICENSE_NO";
export const INVALID_AGENT_STATUS = "INVALID_AGENT_STATUS";
export const INSUFFICIENT_ONLINE_PRODUCT_LISTING =
  "INSUFFICIENT_ONLINE_PRODUCT_LISTING";
export const AGENT_MUST_HAS_PROFILE_PHOTO_LICENSE_NO =
  "AGENT_MUST_HAS_PROFILE_PHOTO_LICENSE_NO";
export const SPECIALIST_SLOT_FULL = "SPECIALIST_SLOT_FULL";
export const SPECIALIST_DUPLICATE = "SPECIALIST_DUPLICATE";
export const SPECIALIST_VIOLATED_EXTEND_STATE =
  "SPECIALIST_VIOLATED_EXTEND_STATE";
export const INSUFFICIENT_QUOTE = "INSUFFICIENT_QUOTE";
export const INVALID_QUOTE = "INVALID_QUOTE";

export const ERROR_ALERT_KEY = {
  DASHBOARD: "AC_ERROR_ALERT_DASHBOARD",
  SUBSCRIPTION: "AC_ERROR_ALERT_SUBSCRIPTION",
  LANDING: "AC_ERROR_ALERT_LANDING",
};

export const ACTIVE = 1;
export const OFFLINE = 2;
export const SUSPENDED = 3;
export const EXPIRED = 4;
export const DELETED = 5;
export const INACTIVE = 6;

export const AREA = 2;
export const CONDO = 1;

export const AREA_MANDATORY_FIELDS = [
  "typeCode",
  "userId",
  "locationLevel1Id",
  "locationLevel2Id",
  "propertyGroupType",
  "durationMonth",
];

export const CONDO_MANDATORY_FIELDS = [
  "typeCode",
  "userId",
  "buildingId",
  "locationLevel2Id",
  "durationMonth",
];

export const SELF_SERVE_AREA_MANDATORY_FIELDS = [
  "locationLevel1Id",
  "locationLevel2Id",
  "propertyGroupType",
  "durationMonth",
];

export const SELF_SERVE_CONDO_MANDATORY_FIELDS = [
  "buildingId",
  "locationLevel2Id",
  "durationMonth",
];
export type SpecialistTable = {
  id: string;
  key: string;
  summary: string | JSX.Element;
  city: string;
  state: string;
  building: string;
  status: JSX.Element;
  categoryType: string;
  startDate: string;
  endDate: string;
  duration: string;
  expandedRow: string | JSX.Element;
  specialist: specialistList_specialistList_data;
  premiumBalance: JSX.Element;
  canExtend: boolean;
  canRedeem: boolean;
  btnExtend?: JSX.Element;
  btnRedeem?: JSX.Element;
};

export interface FilterProps {
  typeCode?: string;
  sortBy?: string;
  page?: number | string;
}

export const SPECIALIST_UPGRADE_EXCEED_LISTING_LIMIT =
  "SPECIALIST_UPGRADE_EXCEED_LISTING_LIMIT";
export const SPECIALIST_UPGRADE_INVALID_PHOTO_SIZE =
  "SPECIALIST_UPGRADE_INVALID_PHOTO_SIZE";
export const SPECIALIST_UPGRADE_INVALID_EXPIRY_DATE =
  "SPECIALIST_UPGRADE_INVALID_EXPIRY_DATE";
export const SPECIALIST_UPGRADE_FREE_PREMIUM_UPGRADE_CREDIT_NOT_READY =
  "FREE_PREMIUM_UPGRADE_CREDIT_NOT_READY";
export const SPECIALIST_UPGRADE_SYSTEM_ERROR = "SYSTEM_ERROR";
export const FROM_SPECIALIST_SELF_SERVE_ADD = "specialistSelfServe.add";
export const FROM_SPECIALIST_SELF_SERVE_LANDING = "specialistSelfServe.landing";

export const isUpgradeFreePremiumUpgradeCreditNotReady = (errors: string[]) => {
  if (errors.length <= 0) {
    return false;
  }

  return errors.some((error) =>
    [INVALID_QUOTE, INSUFFICIENT_QUOTE].includes(error)
  );
};
